import * as React from 'react';

export interface IListBoxContext {
    expandedSectionId: string | null;
}

export const ListBoxContext = React.createContext<IListBoxContext>({
    expandedSectionId: null,
});
